<template>
	<a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
		<a-form ref="ruleForm" :model="form" :rules="rules" class="inline-form mt-15" @submit="onSubmit">
			<!--可编辑区域 start-->
			<div class="hide">
				<a-form-item name="id">
					<a-input v-model:value="form.id" placeholder="请输入id" />
				</a-form-item>
				<a-form-item name="companyCode">
					<a-input v-model:value="form.companyCode" placeholder="请输入companyCode" />
				</a-form-item>
				<a-form-item name="examine">
					<a-input v-model:value="form.examine" />
				</a-form-item>
			</div>
			<a-row :gutter="[24, 8]">
				<a-col :span="12">
					<a-form-item label="机构名称" name="name">
						<a-input v-model:value="form.name" placeholder="请输入机构名称" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="机构类型" name="type">
						<DictSelect v-model:value="form.type" :dict-name="innovation.SERVICETYPE" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="联系人" name="contacts">
						<a-input v-model:value="form.contacts" placeholder="请输入联系人" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="联系电话" name="phone">
						<a-input v-model:value="form.phone" placeholder="请输入联系电话" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="工商注册地址" name="logonAddress">
						<a-input v-model:value="form.logonAddress" placeholder="请输入工商注册地址" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="办公地址" name="workAddress">
						<a-input v-model:value="form.workAddress" placeholder="请输入办公地址" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="服务类型" name="serviceType">
						<multiple-select v-model:value="form.serviceType" :options="options" title-name="name" value-name="id" />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="服务范围" name="scope">
						<a-textarea v-model:value="form.scope" placeholder="请输入服务范围" :auto-size="{ minRows: 6, maxRows: 6 }" />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="近三年主营业务" name="mainBusiness">
						<a-textarea v-model:value="form.mainBusiness" placeholder="近三年主营业务" :auto-size="{ minRows: 6, maxRows: 6 }" />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="机构简介" name="introduction">
						<a-textarea v-model:value="form.introduction" placeholder="请输入机构简介" :auto-size="{ minRows: 6, maxRows: 6 }" />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="资料地址" name="means">
						<FileUpload v-model:value="form.means" />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="logo" name="logo">
						<ImgUpload v-model:value="form.logo" />
					</a-form-item>
				</a-col>
			</a-row>
			<!--可编辑区域 end-->
		</a-form>
	</a-modal>
</template>
<script>
import { innovation, COMMON_VARIABLE } from "@/config/variableConfig"
import DictSelect from "@/components/other/DictSelect";
import { common_controller } from "@/api/commonService";
import { formMixin } from "@/mixins";
import { organizationApi } from "@/api/innovationService";
import FileUpload from "@/components/form/upload/FileUpload";
import ImgUpload from "@/components/form/upload/ImgUpload";

export default {
	name: "index",
	components: { DictSelect, FileUpload, ImgUpload },
	mixins: [formMixin],
	data() {
		return {
			innovation,
			COMMON_VARIABLE,
			options: [],
			form: {
				id: null,
				companyCode: this.$ls.get("companyCode") == null ? this.$ls.get("serviceOrganizationId") : this.$ls.get("companyCode"),
				name: null,
				type: null,
				contacts: null,
				phone: null,
				logonAddress: null,
				workAddress: null,
				serviceType: null,
				scope: null,
				mainBusiness: null,
				introduction: null,
				means: null,
				logo: null,
			},
			rules: {
				id: [],
				companyCode: [],
				name: [],
				type: [],
				contacts: [],
				phone: [],
				logonAddress: [],
				workAddress: [],
				serviceType: [],
				scope: [],
				mainBusiness: [],
				introduction: [],
				means: [],
				logo: [],
				examine: []
			},
			submitUrl: organizationApi.saveOrUpdate
		}
	},
	mounted() {
		this.getDict();
		this.getForm()
	},
	methods: {
		getDict() {
			this.getAction({
				url: common_controller.getDictDataByGroupNumber,
				params: {
					groupNumbers: "servicetypefuwu"
				}
			}).then(res => {
				this.options = res
			})
		},
	}
}
</script>
<style scoped lang="less">
.title {
	display: flex;
	border-bottom: 4px solid #000000;

	h3 {
		font-weight: bold;
	}

	span {
		font-size: 16px;
		margin-top: 4px;
		margin-left: 6px;
	}
}

.hide {
	display: none !important;
}

.border-t {
	border-width: 1px;
	border-style: solid;
	border-color: #dedede;
	border-width: 0;
	border-top-width: 1px;

	.inline-form {
		.ant-form-item {
			display: flex
		}

		.ant-form-item-control-wrapper {
			flex: 1;
		}
	}

	.my-table {
		table-layout: fixed;

		td {
			border: 1px solid #dedede;
			padding: 15px;
		}

		.ant-form-item {
			margin-bottom: 0;
		}
	}
}

.fc-blue {
	color: #409EFF;
}

.fc-green {
	color: #619c1b;
}

.fc-red {
	color: #ff3232;
}
</style>
